import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { initResponsiveTables } from "../util/responsiveTables";
import Sidebar from "../Component/Sidebar/Sidebar";
import { AppHeader } from "../Component/AppShell/AppHeader";
import { ScopeBar } from "../Component/AppShell/ScopeBar";
import "../Component/AppShell/AppShell.css";
import { useSidebar } from "../Context/SidebarContext";
import "../Component/AppShell/GlobalHeader.css";
import useActivityHeartbeat from "../hooks/useActivityHeartbeat";

function Layout() {
  const { open, mode } = useSidebar();
  const location = useLocation();

  const fullScreenPages = ["/home-page"];
  const isFullScreen = fullScreenPages.includes(location.pathname);

  // تحديث 63: مدة النشاط المرصود (نبضة عند التفاعل فقط — بلا محتوى)
  useActivityHeartbeat(location.pathname);

  // الجداول المتجاوبة لكل الصفحات (بطاقات على الجوال، تمرير بعمود ثابت على اللوحي) — util/responsiveTables
  const contentRef = useRef(null);
  useEffect(() => initResponsiveTables(contentRef.current), []);

  /*
    الهيدر الموحّد يُرسَم هنا مرة واحدة لا داخل الصفحات: مستطيل واحد يجمع الرجوع والمسار
    وعنوان الصفحة والإجراءات والبحث والإشعارات واللغة والمستخدم. أي صفحة داخل هذا
    الـLayout تأخذه تلقائياً، ويكفي تعريف بياناتها في pageRegistry.
  */

  return (
    <div className="min-h-screen" style={{ background: "var(--asf-canvas)" }} data-testid="app-layout">
      {/* Sidebar */}
      <a href="#main-content" className="asf-skip-link">تخطَّ إلى المحتوى الرئيسي</a>
      <Sidebar />

      {/* Main Content */}
      <main className={`asf-main asf-main--${mode} ${open ? "is-open" : "is-closed"}`}>
        {/* الهيدر الموحّد (ثابت أعلى الشاشة عند التمرير) */}
        <div className="gh-sticky">
          <AppHeader />
          {!isFullScreen && <ScopeBar />}
        </div>

        {/* asf-app-content: صنف ثابت يحصر توحيد التنسيق في محتوى الصفحات،
            فلا يمسّ تسجيل الدخول ولا ما هو خارج هيكل التطبيق. */}
        <div
          ref={contentRef}
          id="main-content"
          tabIndex={-1}
          className={`asf-app-content ${isFullScreen ? "w-full" : "asf-page"}`}
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;